// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecordVersion } from './record-version';
import {
    RecordVersionFromJSON,
    RecordVersionFromJSONTyped,
    RecordVersionToJSON,
    RecordVersionToJSONTyped,
} from './record-version';
import type { GetRecordHistoryResponseContentQuarantinedInner } from './get-record-history-response-content-quarantined-inner';
import {
    GetRecordHistoryResponseContentQuarantinedInnerFromJSON,
    GetRecordHistoryResponseContentQuarantinedInnerFromJSONTyped,
    GetRecordHistoryResponseContentQuarantinedInnerToJSON,
    GetRecordHistoryResponseContentQuarantinedInnerToJSONTyped,
} from './get-record-history-response-content-quarantined-inner';

/**
 * 
 * @export
 * @interface GetRecordHistoryResponseContent
 */
export interface GetRecordHistoryResponseContent {
    /**
     * 
     * @type {Array<GetRecordHistoryResponseContentQuarantinedInner>}
     * @memberof GetRecordHistoryResponseContent
     */
    quarantined?: Array<GetRecordHistoryResponseContentQuarantinedInner>;
    /**
     * 
     * @type {Array<RecordVersion>}
     * @memberof GetRecordHistoryResponseContent
     */
    versions: Array<RecordVersion>;
}

/**
 * Check if a given object implements the GetRecordHistoryResponseContent interface.
 */
export function instanceOfGetRecordHistoryResponseContent(value: object): value is GetRecordHistoryResponseContent {
    if (!('versions' in value) || value['versions'] === undefined) return false;
    return true;
}

export function GetRecordHistoryResponseContentFromJSON(json: any): GetRecordHistoryResponseContent {
    return GetRecordHistoryResponseContentFromJSONTyped(json, false);
}

export function GetRecordHistoryResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRecordHistoryResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'quarantined': json['quarantined'] == null ? undefined : ((json['quarantined'] as Array<any>).map(GetRecordHistoryResponseContentQuarantinedInnerFromJSON)),
        'versions': ((json['versions'] as Array<any>).map(RecordVersionFromJSON)),
    };
}

export function GetRecordHistoryResponseContentToJSON(json: any): GetRecordHistoryResponseContent {
    return GetRecordHistoryResponseContentToJSONTyped(json, false);
}

export function GetRecordHistoryResponseContentToJSONTyped(value?: GetRecordHistoryResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quarantined': value['quarantined'] == null ? undefined : ((value['quarantined'] as Array<any>).map(GetRecordHistoryResponseContentQuarantinedInnerToJSON)),
        'versions': ((value['versions'] as Array<any>).map(RecordVersionToJSON)),
    };
}
